module.exports = __webpack_public_path__ + "static/reducewaste-7921db37a0250e7775e04a808ad4ea2e.png";